import { http, onSuccess, onFail } from "./http";

export const getShopProducts = (eventKey) =>
    http.get(`/api/cp/event/${eventKey}/module/shop/product`)
        .then(onSuccess, onFail);

export const addShopProduct = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/shop/product`, data)
        .then(onSuccess, onFail);

export const updateShopProduct = (productID, data) =>
    http.put(`/api/cp/event/module/shop/product/${productID}`, data)
        .then(onSuccess, onFail);

export const deleteShopProduct = (productID) =>
    http.delete(`/api/cp/event/module/shop/product/${productID}`)
        .then(onSuccess, onFail);

export const reorderShopProducts = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/shop/product-order`, data)
        .then(onSuccess, onFail);

//Product Image

export const getShopProductImages = (productID) =>
    http.get(`/api/cp/event/module/shop/product/${productID}/images`)
        .then(onSuccess, onFail);

export const getShopProductImage = (imageID) =>
    http.get(`/api/cp/event/module/shop/product/image/${imageID}`)
        .then(onSuccess, onFail);

export const addShopProductImage = (productID, data) =>
    http.post(`/api/cp/event/module/shop/product/${productID}/image`, data)
        .then(onSuccess, onFail);
        
export const deleteShopProductImage = (imageID) =>
    http.delete(`/api/cp/event/module/shop/product/image/${imageID}`)
        .then(onSuccess, onFail);

//Products Report

export const getShopProductOrderReport = (eventKey) =>
    http.get(`/api/cp/event/${eventKey}/module/shop/product/orders/report`)
        .then(onSuccess, onFail);
